export default {
  headers: [
    {
      text: 'Name',
      value: 'name',
    },
    {
      text: 'Features',
      value: 'featuresList',
    },
    {
      text: 'Last Modified',
      value: 'modifiedAt',
    },
    {
      text: 'Actions',
      value: 'actions',
      sort: false,
    },
  ],
  options: {
    loadingText: 'Loading plans... Please wait',
    showSelect: true,
    itemsPerPage: 10,
  },
  bulkActionItems: [{
    title: 'Delete selected',
    id: 'deleteAll',
    action: 'onMulitpleDelete',
  }],
};
